import React from 'react';
import './landingTab.css';
import { Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import LandingDateFilter from './LandingDateFilter'
// import ReactTooltip from "react-tooltip";
import { getColor } from '../../common/ThemeService';
class LandingTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 1,
      filterFlag: false,
      dateRange: props.dateRange,
    }
  }

  componentDidMount = () => {
    this.changeTab(this.props.gameType);
  }

  componentDidUpdate(prevProps) {
    if(this.props !== prevProps ){
      if(this.props.gameType !== prevProps.gameType){
        this.changeTab(this.props.gameType);
      }
      if(this.props.dateRange !== prevProps.dateRange){
        this.setState({dateRange:this.props.dateRange})
      }
        
    }
  }

  changeTab = (gameType) =>{
    if (gameType == "cash") {
      this.setState({ activeTab: 1 })
    } else if (gameType == "PLO") {
      this.setState({ activeTab: 2 })
    } else if (gameType == "tournament") {
      this.setState({ activeTab: 3 })
    } else {
      this.setState({ activeTab: 4 })
    }
  }

  changeFilter = (dateRange) => {
    this.props.submitLandingPageFilter(this.props.gameType, dateRange);
    this.setState({ dateRange, filterFlag: !this.state.filterFlag });
  }

  toggleTab = (tab, gameType, hands) => {
    
      if (this.state.activeTab !== tab) {
        this.setState({ activeTab: tab })
      }
      this.props.submitLandingPageFilter(gameType, this.props.dateRange);
  }

  render() {
    const themeColor = getColor()
    console.log("this.props.gameHandsCounts");
    return (
      <div className="landing-tab-container">
        <Nav tabs className="ul-tab">
          <NavItem className="tab-style">
            <NavLink
              className={"text-color-nav-link "+classnames({ active: this.state.activeTab == 1 })}
              style={this.state.activeTab == 1 ? {
                color: themeColor
              } : {}}
              onClick={() => { this.toggleTab('1', "cash", this.props.gameHandsCounts.cash) }}
            >
              {/* {this.props.gameHandsCounts.cash < 100 ? <ReactTooltip id='NLHCashToolTip'>
                <div className="landing-tab-tool-tip">Play {100 - parseInt(this.props.gameHandsCounts.cash)} hands to unlock!</div>
              </ReactTooltip> : null} */}
              <span 
              // data-tip data-for="NLHCashToolTip" 
              className={this.state.activeTab == 1 ? "landing-tab-text" : ""} data-e2e="nlhCashGames">NLH Cash</span>
              {/* {this.props.gameHandsCounts.cash < 100 ? <i className="fa fa-lock tab-lock-icon"></i> : null} */}
            </NavLink>
          </NavItem>
          <NavItem className="tab-style">
            <NavLink
              className={"text-color-nav-link "+classnames({ active: this.state.activeTab == 2 })}
              style={this.state.activeTab == 2 ? {
                color: themeColor
              } : {}}
              onClick={() => { this.toggleTab('2', "PLO", this.props.gameHandsCounts.PLO) }}
            >
              {/* {this.props.gameHandsCounts.PLO < 100 ? <ReactTooltip id='PLOCashToolTip'>
                <div className="landing-tab-tool-tip">Play {100 - parseInt(this.props.gameHandsCounts.PLO)} hands to unlock!</div>
              </ReactTooltip> : null} */}
              <span 
              // data-tip data-for="PLOCashToolTip" 
              className={this.state.activeTab == 2 ? "landing-tab-text" : ""} 
              data-e2e="ploCash">PLO Cash</span>
              {/* {this.props.gameHandsCounts.PLO < 100 ? <i className="fa fa-lock tab-lock-icon"></i> : null} */}

            </NavLink>
          </NavItem>
          <NavItem className="tab-style">
            <NavLink
              className={"text-color-nav-link "+classnames({ active: this.state.activeTab == 3 })}
              style={this.state.activeTab == 3 ? {
                color: themeColor
              } : {}}
              onClick={() => { this.toggleTab('3', "tournament", this.props.gameHandsCounts.tournament) }}
            >
              {/* {this.props.gameHandsCounts.tournament < 100 ? <ReactTooltip id='tournamentToolTip'>
                <div className="landing-tab-tool-tip">Play {100 - parseInt(this.props.gameHandsCounts.tournament)} hands to unlock!</div>
              </ReactTooltip> : null} */}
              <span 
              // data-tip data-for="tournamentToolTip"
               className={this.state.activeTab == 3 ? "landing-tab-text" : ""}data-e2e="tournament">MTT's</span>
              {/* {this.props.gameHandsCounts.tournament < 100 ? <i className="fa fa-lock tab-lock-icon"></i> : null} */}
            </NavLink>
          </NavItem>
          <NavItem className="tab-style">
            <NavLink
              className={"text-color-nav-link "+classnames({ active: this.state.activeTab == 4 })}
              style={this.state.activeTab == 4 ? {
                color: themeColor
              } : {}}
              onClick={() => { this.toggleTab('4', "spin", this.props.gameHandsCounts.spin) }}
            >
              {/* {this.props.gameHandsCounts.spin < 100 ? <ReactTooltip id='spinToolTip'>
                <div className="landing-tab-tool-tip">Play {100 - parseInt(this.props.gameHandsCounts.spin)} hands to unlock!</div>
              </ReactTooltip> : null} */}
              <span 
              // data-tip data-for="spinToolTip"
               className={this.state.activeTab == 4 ? "landing-tab-text" : ""} data-e2e="spin">Spins</span>
              {/* {this.props.gameHandsCounts.spin < 100 ? <i className="fa fa-lock tab-lock-icon"></i> : null} */}
            </NavLink>
          </NavItem>
        </Nav>
        <div className="landing-tab-right-div" >
          <span style={{cursor:"pointer"}} onClick={() => this.setState({ filterFlag: !this.state.filterFlag })}>{this.state.dateRange}
            <i data-e2e={this.state.dateRange} className="fa fa-angle-down landing_tab_filter_icon"></i>
          </span>
          {this.state.filterFlag && <LandingDateFilter changeFilter={this.changeFilter} />}
        </div>

      </div>
    )
  }
}




export default LandingTab;


/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/LandingTab.js
 **/